<template>
  <div class="datepicker-popover m-0">
    <div class="datepicker-popover__input">
      <Icon name="calendar" extra-classes="icon--md color-mute mr-2" />

      <input
        class="datepicker-popover__toggler form-control"
        :id="`${id}-${property}`"
        type="text"
        :value="dateOfArrival"
        readonly
        autocomplete="off"
        @focus="() => setOpenDatePicker(id)"
      />
    </div>

    <div
      v-show="isDatePickerOpen(id)"
      class="datepicker-popover__popover bg-gray shadow p-3"
    >
      <label :id="`${id}-${property}`" class="form-label d-block color-text-dark font-weight-bold mb-2">
        {{ i18n.dateOfArrival }}
      </label>

      <div id="date-of-arrival" data-controller="datepicker">
        <input
          :id="`${id}-${property}`"
          type="hidden"
          name="date"
          :value="dateOfArrival"
          data-target="datepicker.input"
          @change="(e) => onDateSelect(e.target.value)"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import Icon from '@/cart/components/Icon.vue';

export default {
  components: {
    Icon,
  },

  props: {
    property: {
      type: String,
      required: true,
    },

    date: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      id: `datepicker-${uuidv4()}`,
      dateOfArrival: this.date,
    };
  },

  computed: {
    ...mapGetters([
      'isDatePickerOpen',
    ]),
  },

  created() {
    window.addEventListener('click', ({ target }) => this.removeOpenDatePicker(target));
  },

  destroyed() {
    window.removeEventListener('click', ({ target }) => this.removeOpenDatePicker(target));
  },

  methods: {
    ...mapMutations([
      'setCartField',
      'setOpenDatePicker',
    ]),

    onDateSelect(date) {
      this.dateOfArrival = date;
      this.setCartField(['dateOfArrival', date]);
      this.setOpenDatePicker(null);
    },

    removeOpenDatePicker(target) {
      if (target.closest('.datepicker-popover')) return;

      this.setOpenDatePicker(null);
    },
  },
};
</script>
